<template>
  <fieldset class="lib__form__fieldset">
    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">{{ $t('contact.form.contactInformation') }}</legend>
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <select-box :label="$t('contact.form.companyType')" :options="companyTypes" required v-model="value.companyType"></select-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.companyName')" required v-model="value.companyName" :max="50" :rules="{ name_valid_characters: true }"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.vatNumber')" v-model="value.vatNumber" vat-number onlyCharAndNumbers></text-box>
        </div>
        <div class="col-xs-12 col-md-6" v-if="!isSmartMeterForm">
          <text-box :label="$t('contact.form.customerRef')" v-model="value.customerRef"></text-box>
        </div>
        <div class="col-xs-12">
          <address-form :value="value.address"></address-form>
        </div>
      </div>
    </fieldset>

    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">{{ $t('contact.person') }} :</legend>
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <civility-selector :data-vv-as="$t('contact.form.civility')" name="civility" v-model="value.civility"></civility-selector>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.firstname')" required v-model="value.firstname" :rules="{ name_valid_characters: true }"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.lastname')" required v-model="value.lastname" :rules="{ name_valid_characters: true }"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.job')" required v-model="value.job"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <date-selector :label="$t('contact.form.birthDate')" v-if='showBirthdate' required v-model="value.birthDate"></date-selector>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.email')" :labelTooltip="emailTooltip" email required v-model="emailAddress"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <phone-box :label="$t('contact.form.mobile')" :labelTooltip="mobileTooltip" required v-model="value.phone"></phone-box>
        </div>
      </div>
    </fieldset>
  </fieldset>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import AddressForm from '@/components/inputs/Contact/AddressForm.vue'
import { ContactCompany } from '@/models'
import ContactBaseForm from './ContactBaseForm'

@Component({
  components: {
    AddressForm
  }
})
export default class ContactCompanyForm extends ContactBaseForm {
  //#region [Property]
  @Prop({ type: Object, required: true })
  public readonly value!: ContactCompany
  @Prop({ type: Boolean, required: false, default: false })
  public readonly isSmartMeterForm!: boolean
  @Prop({ type: Boolean, required: false, default: true })
  public readonly showBirthdate!: boolean
  //#endregion

  //#region [Computed]
  public get companyTypes(): Array<{ text: string; value: string; disable?: boolean }> {
    const list: Array<{ text: string; value: string; disable?: boolean }> = []
    for (let i = 0; i < 12; i++) {
      list.push({ value: i.toString(), text: this.$t(`contact.companyType.${i}`) as string })
    }
    return list
  }
  protected get emailAddress(): string | null {
    return this.value.email
  }
  protected set emailAddress(value: string | null) {
    this.value.email = value?.trim() ?? null
  }
  //#endregion
}
</script>
